import React from 'react';

interface Props {
  readonly value: number | string | null;
  readonly _data: any;
  readonly name: string;
}

export const FormattedNumberCell: React.FC<Props> = ({ value, _data, name }) => {
  if (value === null || value === undefined) {
    return <span></span>;
  }

  const numeric = Number(value);
  if (isNaN(numeric)) {
    return <span>{String(value)}</span>;
  }

  const formatted = numeric.toLocaleString('en-US', {
    minimumFractionDigits: name === 'commrate' ? 1 : 0,
    maximumFractionDigits: name === 'commrate' ? 5 : 0,
  });

  return <span>{formatted}</span>;
};
